// useUpdateOrderStatusMutation.js
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { deletePartFromRepairOrder } from "api/repair-orders";

const useDeletePart = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(deletePartFromRepairOrder, {
    onMutate: async ({ repairOrderId, partId }) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({
        queryKey: ["repairOrder", repairOrderId],
      });

      // Snapshot the previous data
      const previousOrder = queryClient.getQueryData([
        "repairOrder",
        repairOrderId,
      ]);

      if (!previousOrder) {
        console.error("No previous order found");
        console.log("repairOrderId", repairOrderId);
        return;
      }

      //Remove the service from the services array
      queryClient.setQueryData(["repairOrder", repairOrderId], (old) => ({
        ...old,
        updatedAt: dayjs().toISOString(),
        repairOrderParts: old.repairOrderParts.filter(
          (part) => part.id !== partId
        ),
      }));

      // Return context with the previous order for rollback
      return { previousOrder };
    },
    onError: (error, variables, context) => {
      if (context?.previousOrder) {
        queryClient.setQueryData(
          ["repairOrder", variables.repairOrderId],
          context.previousOrder
        );
      }
      console.log(error.response);
      console.error(error?.response?.data?.message || "Error deleting part");
      enqueueSnackbar("Failed to delete part", { variant: "error" });
    },
    onSuccess: (data, variables) => {
      enqueueSnackbar("Part delete successfully", { variant: "success" });
    },
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries(["repairOrder", variables.repairOrderId]);
    },
  });
};

export default useDeletePart;
